import Box from '@mui/material/Box'
import NavBar from './NavBar'

export default function Header() {
  return (
    <Box sx={{}}>
      <header>
        <NavBar />
      </header>
    </Box>
  )
}
